import PropTypes from 'prop-types';
import React from 'react';


function Label({
  bold=false,
  label,
  underline=false,
  red=false,
  blue=false,
  green=false,
  nomargin=false,
  style=undefined,
  validationFor=undefined,
  ...other
}:{
  bold?: boolean,
  label: React.ReactNode|string|undefined,
  underline?: boolean,
  red?: boolean,
  blue?: boolean,
  green?: boolean,
  nomargin?: boolean,
  style?: React.CSSProperties|undefined,
  validationFor?:string|undefined,
  [x:string]: any;
}) {
  const labelText = bold ? <strong>{label}</strong> : <>{label}</>;

  const labelNode = underline
    ? <u>{labelText}</u>
    : <>{labelText}</>;

  const baseStyle = style || {};
  
  let labelStyle = red ? { ...baseStyle, color: '#bf0000' } : baseStyle;
  labelStyle = blue ? { ...labelStyle, color: '#449ee2' } : labelStyle;
  labelStyle = green ? { ...labelStyle, color: '#008000' } : labelStyle;

  if (nomargin) {
    labelStyle = {...labelStyle, marginBottom: '0px'};
  }
  
  return <label style={labelStyle} className="e-ifms-label" data-validationfor={`${validationFor}`} {...other}>{labelNode}</label>;
}

Label.defaultProps = {
  label: '',
  bold: false,
  underline: false,
  red: false,
  blue: false,
  green: false,
  nomargin: false,
};

Label.propTypes = {
  bold: PropTypes.bool.isRequired,
  underline: PropTypes.bool.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  red: PropTypes.bool.isRequired,
  blue: PropTypes.bool.isRequired,
  green: PropTypes.bool.isRequired,
  nomargin: PropTypes.bool.isRequired,
  validationFor: PropTypes.string,
};


export default React.memo(Label);
